import React from "react";
import { Box, Heading, HStack, Icon, Text, Wrap, WrapItem, useColorModeValue } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";

interface CredentialTitleProps {
  programName?: string;
  recipientName?: string;
  orgName?: string;
  issueDate?: string;
}

export const CredentialTitle: React.FC<CredentialTitleProps> = ({
  programName,
  recipientName,
  orgName,
  issueDate,
}) => {
  const badgeBg = useColorModeValue("green.50", "green.900");
  const badgeColor = useColorModeValue("green.700", "green.200");
  const mutedColor = useColorModeValue("gray.600", "gray.400");
  const strongColor = useColorModeValue("gray.800", "gray.100");

  const facts = [
    recipientName && { label: "Awarded to", value: recipientName },
    orgName && { label: "Issued by", value: orgName },
    issueDate && { label: "On", value: issueDate },
  ].filter(Boolean) as { label: string; value: string }[];

  return (
    <Box>
      <HStack
        display="inline-flex"
        spacing={2}
        bg={badgeBg}
        color={badgeColor}
        px={3}
        py={1}
        rounded="full"
        mb={3}
      >
        <Icon as={FaCheckCircle} boxSize={3.5} />
        <Text fontSize={{ base: "xs", md: "sm" }} fontWeight="semibold">
          Verified credential
        </Text>
      </HStack>

      <Heading as="h1" fontSize={{ base: "xl", md: "3xl" }} fontWeight="bold" lineHeight="shorter" color={strongColor}>
        {programName || "Certificate"}
      </Heading>

      {facts.length > 0 && (
        <Wrap spacingX={5} spacingY={1} mt={2}>
          {facts.map((fact) => (
            <WrapItem key={fact.label}>
              <Text fontSize="sm" color={mutedColor}>
                {fact.label}{" "}
                <Text as="span" fontWeight="semibold" color={strongColor}>
                  {fact.value}
                </Text>
              </Text>
            </WrapItem>
          ))}
        </Wrap>
      )}
    </Box>
  );
};
